// react
import React, { useState } from "react";
import ReactDOM from "react-dom";

// components
import { Single as SingleSelectRole } from "../../../../components/Inputs/SelectRole/Single";

// dependencies
import PropTypes from "../../../../lib/prop-types";

// Hydrates the server-rendered role mount point with the picker; the selected id is
// written to data-role-id, which collect() in add-employee.js submits.
const RoleCustomField = ({ elementID }) => {
	const rootElement = document.getElementById(elementID);
	const [role, setRole] = useState(null);

	const handleChange = (value) => {
		setRole(value);
		if (!rootElement) {
			return;
		}
		if (value && value.id) {
			rootElement.setAttribute("data-role-id", value.id);
		} else {
			rootElement.removeAttribute("data-role-id");
		}
	};

	if (!rootElement) {
		return null;
	}

	return ReactDOM.createPortal(<SingleSelectRole value={role} onChange={handleChange} isClearable />, rootElement);
};

RoleCustomField.propTypes = {
	elementID: PropTypes.string.isRequired,
};

export default RoleCustomField;
